export const authEmulatorURL: URL = new URL('http://localhost:9099');
export const storageEmulatorURL: URL = new URL('http://localhost:9199');
export const firestoreEmulatorURL: URL = new URL('http://localhost:8080');
